import { startCase } from "lodash";

function parseErrorMessage(messages: Record<string, string | string[]>) {
  const message = Array.isArray(messages) ? messages[0] : Object.values(messages)[0];
  const text = Array.isArray(message) ? message[0] : message;
  return text;
}

export function getErrorMessage(messages: Record<string, string | string[]>) {
  const keys = [Object.keys(messages)[0]];
  let errorText = parseErrorMessage(messages);
  while (typeof errorText !== "string" && typeof errorText !== "undefined") {
    keys.push(Object.keys(errorText)[0]);
    errorText = parseErrorMessage(errorText);
  }
  const fullText = `${keys.map(startCase).join(": ")}: ${errorText}`;
  return fullText;
}
